import _ from 'lodash';

let requestById = {};

const _tryBatchGetRequest = (flux) => {
  if (!_.isEmpty(requestById)) {
    const requestByIdCopy = _.clone(requestById);

    const ids = _.keys(requestById);

    // The /componentInstances/:id/resources endpoint supports the following id's:
    //   1. single component instance id (e.g., id1)
    //   2. comma separated component instance id's (e.g., id1,id2,id3)
    // Because we are overloading the endpoint to support multiple ID's, this is more
    // of a convenience/performance optimization, rather than a core feature. Thus,
    // it doesn't make sense to change the endpoint to always return an array of responses
    // even when there is just a single ID. However, the endpoint returns an array
    // if the ID contains a comma. This is by design as this need was somewhat anticipated.
    // This way, we can keep the endpoint's design pure, but flexible enough for
    // clients to fulfill it needs.
    // Alternatively, we can handle it purely on the client side. i.e., wrap the repsponse
    // in an array if it's an object.
    // In the future, we can consider separate batch endpoints as more needs like this
    // arise.
    if (ids.length === 1) {
      // Push empty string which makes .join to append "," at the end
      ids.push('');
    }

    const commaSeparatedIds = ids.join(',');

    // NOTE: Quick fix for some ComponentContainer instances not having params values
    // TODO: Fix it better. e.g., /:id/resources?vars='{}','{}','{}'
    const params = _.assign.apply(_, _.map(requestByIdCopy, r => r.params));
    
    flux.request({
      url: `/componentInstances/${commaSeparatedIds}/resources`,
      params
    }).then(resps => {
      _.forEach(resps, (resp, i) => {
        const request = requestByIdCopy[ids[i]];

        if (request) {
          request.resolve(resp);
        }
      });
    }).catch(error =>
      // reject all requests
      _.forOwn(
        requestByIdCopy, request => request.reject(error)
      )
    );

    requestById = {};
  }
};

const readComponentInstanceResourceList = (componentInstance, { propPath = '', vars = {} } = {}) => {
  const {
    context: {
      flux
    },
    props: {
      componentInstanceId,
      FRN_componentInstanceId,
      params,
      FRN_flux,
      widgetId
    }
  } = componentInstance;

  // WEB-4658 if widgetId is valid, we get data by widgetId
  if (widgetId) {
    const newFlux = flux || FRN_flux;
    return new Promise((resolve, reject) => {
      newFlux.request(
        { url: `/componentInstances/slideshow-${widgetId}/resources` }
      ).then(resp => resolve([resp])
      ).catch(error => reject(error));
    });
  }

  let id = componentInstanceId || FRN_componentInstanceId;

  if (propPath) {
    id += '.props.' + propPath;
  }

  const promise = new Promise((resolve, reject) => {
    requestById[id] = {
      params: _.assign(_.clone(params), vars),
      resolve,
      reject
    };
  });

  _tryBatchGetRequest(flux || FRN_flux);

  return promise;
};

export default readComponentInstanceResourceList;



// WEBPACK FOOTER //
// ./app/lib/frankly/readComponentInstanceResourceList.js